export interface Article {
  id: string;
  title: string;
  slug: string;
  category: 'football' | 'basketball' | 'comprehensive';
  categoryName: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
  viewCount: number;
  commentCount: number;
  isHot: boolean;
  isFeatured: boolean;
}

export const categories = [
  { slug: 'football', name: '足球', icon: 'ri-football-line' },
  { slug: 'basketball', name: '篮球', icon: 'ri-basketball-line' },
  { slug: 'comprehensive', name: '综合体育', icon: 'ri-medal-line' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '2026世界杯亚洲区预选赛：中国队2-1力克日本队，创造历史性胜利',
    slug: 'china-vs-japan-world-cup-qualifier-2026',
    category: 'football',
    categoryName: '足球',
    excerpt: '在2026年世界杯亚洲区预选赛的关键战役中，中国男足凭借武磊和张玉宁的进球，以2-1击败日本队，取得了一场载入史册的胜利。这场比赛展现了中国足球近年来的显著进步。',
    content: `<p>在2026年世界杯亚洲区预选赛第三阶段的关键战役中，中国男足在沈阳奥体中心迎战日本队。这场比赛对于两支球队来说都至关重要，胜者将在出线竞争中占据有利位置。</p>
    <h2>比赛回顾</h2>
    <p>比赛开场仅8分钟，中国队就展现出强烈的进攻欲望。武磊在右路接到队友的精妙传球后，凭借出色的个人能力突破日本队防线，一脚低射破门，为中国队取得梦幻开局。</p>
    <p>第35分钟，日本队通过一次快速反击扳平比分。然而，中国队并未因此气馁。下半场第67分钟，替补登场的张玉宁在禁区内接到角球传中，头球攻门得分，将比分改写为2-1。</p>
    <h2>战术分析</h2>
    <p>中国队主教练本场比赛采用了4-3-3阵型，中场三人组的积极拼抢有效限制了日本队的传控节奏。数据显示，中国队全场完成了18次抢断，比日本队多出6次。</p>
    <p>日本队虽然在控球率上以58%占优，但在关键传球和射门转化率方面均落后于中国队。中国队全场7次射门4次射正，效率极高。</p>
    <h2>赛后声音</h2>
    <p>中国队主教练在赛后新闻发布会上表示："这是全队努力的结果，球员们在场上展现了顽强的斗志和出色的执行力。这场胜利将给我们在接下来的预选赛中带来巨大的信心。"</p>
    <p>本场最佳球员武磊则表示："能够在主场球迷面前取得这样一场胜利，感觉非常特别。我们会继续努力，争取晋级2026年世界杯。"</p>
    <p>这场胜利使中国队在小组积分榜上升至第二位，距离直接晋级世界杯的目标又近了一步。接下来的比赛，中国队将客场挑战澳大利亚队。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20celebrating%20a%20dramatic%20goal%20in%20a%20packed%20stadium%20with%20red%20jerseys%20and%20waving%20flags%2C%20professional%20sports%20photography%20style%2C%20dramatic%20lighting%2C%20clean%20background%2C%20action%20shot%20with%20emotional%20intensity&width=1200&height=675&seq=article-football-01&orientation=landscape',
    author: '王涛',
    publishDate: '2026-08-10',
    tags: ['世界杯预选赛', '中国足球', '日本队', '武磊'],
    viewCount: 128500,
    commentCount: 3621,
    isHot: true,
    isFeatured: true,
  },
  {
    id: '2',
    title: 'NBA新赛季前瞻：湖人队阵容大换血，詹姆斯能否再夺总冠军？',
    slug: 'nba-preview-lakers-roster-revamp-2026',
    category: 'basketball',
    categoryName: '篮球',
    excerpt: '洛杉矶湖人队在休赛期进行了大规模阵容调整，引进了多位全明星级别球员。在新赛季即将开始之际，我们深入分析湖人队的新阵容以及他们在西部联盟的竞争力。',
    content: `<p>随着2026-2027赛季NBA常规赛的临近，洛杉矶湖人队的阵容变化成为球迷关注的焦点。在经历了一个令人失望的季后赛之后，湖人管理层在休赛期进行了大刀阔斧的改革。</p>
    <h2>阵容变化一览</h2>
    <p>湖人队在休赛期通过交易和自由球员市场引进了三位全明星级别的球员：控球后卫达米安·利拉德、小前锋杰森·塔图姆以及中锋鲁迪·戈贝尔。这三笔交易显著提升了球队在各个位置上的实力。</p>
    <p>同时，球队保留了核心球员勒布朗·詹姆斯和安东尼·戴维斯。这样的阵容配置使湖人队在新赛季的夺冠赔率中跃升至联盟第一。</p>
    <h2>战术展望</h2>
    <p>新赛季湖人队预计将采用更加多样化的进攻战术。利拉德的加盟为球队带来了稳定的外线投射能力，而戈贝尔则提供了内线防守和篮板保障。詹姆斯和塔图姆的锋线组合将是对手防守的巨大难题。</p>
    <p>主教练在接受采访时表示："我们拥有一支深度和天赋兼备的阵容，关键在于如何让所有球员在体系中发挥最大作用。我对新赛季充满期待。"</p>
    <h2>西部格局分析</h2>
    <p>西部联盟的竞争依然激烈。掘金队、雷霆队和勇士队都保持了强大的阵容。湖人队需要在常规赛中建立良好的化学反应，才能在季后赛中走得更远。</p>
    <p>对于39岁的勒布朗·詹姆斯来说，新赛季可能是他追逐第五枚总冠军戒指的最佳机会。他在社交媒体上写道："我已经准备好了，让我们一起创造历史。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Los%20Angeles%20Lakers%20basketball%20team%20in%20gold%20and%20purple%20jerseys%20on%20court%20during%20intense%20game%20action%2C%20professional%20NBA%20photography%20style%2C%20dramatic%20arena%20lighting%2C%20clean%20sports%20background&width=1200&height=675&seq=article-basketball-01&orientation=landscape',
    author: '李明',
    publishDate: '2026-08-09',
    tags: ['NBA', '湖人队', '詹姆斯', '新赛季'],
    viewCount: 98600,
    commentCount: 2845,
    isHot: true,
    isFeatured: true,
  },
  {
    id: '3',
    title: '巴黎奥运会倒计时：中国代表团备战情况全面解读',
    slug: 'paris-olympics-china-preparation-2026',
    category: 'comprehensive',
    categoryName: '综合体育',
    excerpt: '距离巴黎奥运会开幕还有不到一年时间，中国体育代表团各项目队伍正在紧锣密鼓地备战。从传统优势项目到新兴项目，中国运动员展现出全面的竞争力。',
    content: `<p>随着巴黎奥运会的临近，中国体育代表团的备战工作进入最后冲刺阶段。各项目国家队正在全国各地训练基地进行封闭集训，为在奥运赛场上争金夺银做最后的准备。</p>
    <h2>传统优势项目</h2>
    <p>在跳水、举重、乒乓球、羽毛球等传统优势项目上，中国队依然保持着世界领先水平。跳水队在新老交替后展现出强劲实力，新一代选手在世界杯系列赛中表现抢眼。</p>
    <p>乒乓球队在完成新老交替后，年轻选手逐渐挑起大梁。在最近的世锦赛上，中国队包揽了全部五个项目的金牌，展现出强大的统治力。</p>
    <h2>新兴项目突破</h2>
    <p>在滑板、攀岩、冲浪等新兴奥运项目上，中国运动员也取得了显著进步。特别是在攀岩项目上，中国选手在世界杯分站赛中多次站上领奖台。</p>
    <p>田径和游泳两个基础大项同样值得关注。中国田径队在短跑和跳跃项目上涌现出多位新星，游泳队也在中长距离自由泳项目上具备了争金实力。</p>
    <h2>备战保障</h2>
    <p>国家体育总局表示，将全力做好巴黎奥运会的备战保障工作，包括科技助力、医疗保障、心理辅导等全方位支持，确保运动员以最佳状态参赛。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20Olympic%20athletes%20training%20in%20modern%20sports%20facility%20with%20red%20tracksuits%2C%20professional%20sports%20photography%2C%20dynamic%20action%2C%20clean%20background%2C%20motivational%20atmosphere&width=1200&height=675&seq=article-olympic-01&orientation=landscape',
    author: '张华',
    publishDate: '2026-08-08',
    tags: ['奥运会', '中国代表团', '备战', '巴黎'],
    viewCount: 75200,
    commentCount: 1923,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '4',
    title: '欧冠联赛：皇马3-0完胜拜仁，晋级决赛',
    slug: 'champions-league-real-madrid-vs-bayern-2026',
    category: 'football',
    categoryName: '足球',
    excerpt: '在欧洲冠军联赛半决赛次回合比赛中，皇家马德里在伯纳乌球场以3-0完胜拜仁慕尼黑，以总比分4-1晋级决赛。',
    content: `<p>在欧洲冠军联赛半决赛次回合的焦点战中，皇家马德里在主场伯纳乌球场迎战拜仁慕尼黑。首回合两队1-1战平，次回合的胜者将晋级决赛。</p>
    <h2>比赛进程</h2>
    <p>比赛第20分钟，维尼修斯在左路突破后传中，贝林厄姆头球破门，皇马取得领先。第55分钟，罗德里戈在禁区前沿远射得手，比分扩大为2-0。第78分钟，替补登场的恩德里克单刀破门，锁定胜局。</p>
    <p>拜仁慕尼黑全场控球率达到62%，但射门次数和射正次数均落后于皇马。皇马的高效反击成为取胜关键。</p>
    <h2>决赛展望</h2>
    <p>皇马将在决赛中对阵曼城队，这将是两支欧洲顶级球队之间的巅峰对决。皇马主教练安切洛蒂赛后表示："我们展现了欧冠基因，决赛将是一场精彩的比赛。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20players%20celebrating%20a%20goal%20in%20white%20jerseys%20at%20Santiago%20Bernabeu%20stadium%20under%20floodlights%2C%20professional%20sports%20photography%2C%20dramatic%20atmosphere%2C%20clean%20composition&width=1200&height=675&seq=article-football-02&orientation=landscape',
    author: '刘洋',
    publishDate: '2026-08-07',
    tags: ['欧冠', '皇马', '拜仁', '贝林厄姆'],
    viewCount: 65300,
    commentCount: 1856,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '5',
    title: 'CBA新赛季改革方案出炉：外援政策重大调整',
    slug: 'cba-new-season-reform-foreign-player-policy-2026',
    category: 'basketball',
    categoryName: '篮球',
    excerpt: 'CBA联赛官方公布了2026-2027赛季的多项改革方案，其中最引人关注的是外援政策的重大调整，新规将对联赛格局产生深远影响。',
    content: `<p>CBA联赛官方今日正式公布了2026-2027赛季的多项改革方案。这些改革旨在提升联赛竞争力和观赏性，促进中国篮球的可持续发展。</p>
    <h2>外援政策调整</h2>
    <p>新赛季外援政策最显著的变化是：每支球队可以注册三名外援，但比赛中同时上场的外援人数限制为两人。此外，外援的薪资帽将从目前的500万美元提升至650万美元。</p>
    <p>这一政策调整旨在平衡各队实力，同时给予本土球员更多的上场机会和发展空间。联赛官方表示，新政策将在试行一个赛季后进行评估。</p>
    <h2>赛制改革</h2>
    <p>常规赛场次将从52场增加到56场，季后赛名额从12个增加到14个。季后赛赛制也进行了调整，首轮将采用三场两胜制，增加了比赛的悬念。</p>
    <h2>青训体系升级</h2>
    <p>联赛还将加大对青训体系的投入，要求每支CBA球队必须拥有完善的U19和U17梯队。同时设立了青年联赛，为年轻球员提供更多的比赛机会。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=CBA%20Chinese%20basketball%20league%20game%20in%20modern%20arena%20with%20players%20in%20action%2C%20professional%20sports%20photography%2C%20dramatic%20lighting%2C%20packed%20stadium%20atmosphere&width=1200&height=675&seq=article-basketball-02&orientation=landscape',
    author: '陈伟',
    publishDate: '2026-08-06',
    tags: ['CBA', '外援政策', '篮球改革'],
    viewCount: 48200,
    commentCount: 1356,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '6',
    title: '世界田径锦标赛：中国短跑新星苏炳添接班人横空出世',
    slug: 'world-athletics-china-sprinter-2026',
    category: 'comprehensive',
    categoryName: '综合体育',
    excerpt: '在世界田径锦标赛男子100米比赛中，中国22岁小将刘浩然以9秒89的成绩获得铜牌，成为继苏炳添之后又一位突破10秒大关的中国短跑选手。',
    content: `<p>在布达佩斯举行的世界田径锦标赛男子100米决赛中，中国22岁新星刘浩然以9秒89的个人最好成绩获得铜牌，创造了中国短跑新的历史。</p>
    <h2>比赛详情</h2>
    <p>决赛中，刘浩然在第六道出发。起跑反应时间为0.138秒，前半程他紧咬美国选手科尔曼，在60米后开始发力，最终以9秒89的成绩第三个冲过终点线。</p>
    <p>美国选手科尔曼以9秒79获得金牌，牙买加选手汤普森以9秒84获得银牌。刘浩然成为继苏炳添之后，第二位在世界大赛男子100米项目上获得奖牌的中国选手。</p>
    <h2>未来展望</h2>
    <p>刘浩然赛后表示："苏炳添是我的偶像，能够追随他的脚步在世界舞台上取得成绩，我感到非常自豪。我的目标是继续进步，争取在奥运会上为中国田径争光。"</p>
    <p>中国田径协会对此表示高度评价，认为刘浩然的崛起标志着中国短跑进入了新的发展阶段，后继有人。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20male%20sprinter%20in%20red%20uniform%20sprinting%20on%20track%20during%20world%20championship%20race%2C%20professional%20sports%20photography%2C%20motion%20blur%20effect%2C%20stadium%20background%2C%20intense%20competition&width=1200&height=675&seq=article-track-01&orientation=landscape',
    author: '赵强',
    publishDate: '2026-08-05',
    tags: ['田径', '短跑', '中国速度', '世锦赛'],
    viewCount: 56800,
    commentCount: 2103,
    isHot: true,
    isFeatured: false,
  },
  {
    id: '7',
    title: '中超联赛积分榜：上海申花领跑，争冠形势白热化',
    slug: 'csl-standings-shanghai-shenhua-leads-2026',
    category: 'football',
    categoryName: '足球',
    excerpt: '2026赛季中超联赛进入最后三分之一赛程，上海申花以5分优势领跑积分榜。上海海港和北京国安排名二三位，争冠形势日趋白热化。',
    content: `<p>2026赛季中超联赛已进行了22轮比赛，争冠和保级形势逐渐明朗。上海申花凭借稳定的发挥，目前以5分优势领跑积分榜。</p>
    <h2>积分榜前列</h2>
    <p>上海申花以50分高居榜首，上海海港以45分紧随其后，北京国安以43分排名第三。山东泰山和成都蓉城分别以40分和38分排名第四和第五。</p>
    <p>上海申花本赛季攻防两端表现出色，22轮比赛打入52球仅失18球，净胜球高达34个。外援前锋马莱莱以18球领跑射手榜。</p>
    <h2>争冠分析</h2>
    <p>联赛还剩8轮，上海申花的赛程相对有利，剩余的对手中仅有山东泰山一支排名前五的球队。上海海港和北京国安则需要在相互之间的直接对话中争取积分。</p>
    <p>专家分析认为，上海申花夺冠概率约为65%，但足球比赛的魅力在于不确定性，任何情况都可能发生。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Shanghai%20Shenhua%20football%20team%20in%20blue%20jerseys%20playing%20in%20Chinese%20Super%20League%20match%2C%20professional%20sports%20photography%2C%20packed%20stadium%2C%20dynamic%20action%20shot&width=1200&height=675&seq=article-football-03&orientation=landscape',
    author: '王涛',
    publishDate: '2026-08-04',
    tags: ['中超', '上海申花', '积分榜', '争冠'],
    viewCount: 42800,
    commentCount: 1523,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '8',
    title: '网球大滿贯：郑钦文闯入美网女单八强，创个人最佳战绩',
    slug: 'us-open-zheng-qinwen-quarterfinal-2026',
    category: 'comprehensive',
    categoryName: '综合体育',
    excerpt: '中国网球名将郑钦文在美国网球公开赛女单第四轮比赛中直落两盘击败对手，职业生涯首次闯入大滿贯赛事八强。',
    content: `<p>在美国网球公开赛女单第四轮比赛中，中国选手郑钦文以6-4、6-3直落两盘击败世界排名第八的白俄罗斯选手萨巴伦卡，职业生涯首次闯入大滿贯赛事八强。</p>
    <h2>比赛回顾</h2>
    <p>首盘比赛，郑钦文在第三局完成关键破发，随后凭借稳定的发球保住了优势，以6-4先下一盘。第二盘中，郑钦文打出更加积极主动的网球，两次破发对手，最终以6-3锁定胜局。</p>
    <p>全场比赛，郑钦文发出8记Ace球，一发得分率高达78%，展现出强大的发球实力。底线对抗中，她的正手进攻频频制造威胁，让对手难以招架。</p>
    <h2>历史意义</h2>
    <p>这是继李娜之后，又一位闯入大滿贯八强的中国女子网球选手。郑钦文的世界排名预计将在本次美网后进入前十，创造个人职业生涯新高。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20female%20tennis%20player%20in%20white%20outfit%20hitting%20powerful%20forehand%20on%20blue%20hard%20court%20during%20grand%20slam%20match%2C%20professional%20sports%20photography%2C%20clean%20background%2C%20athletic%20pose&width=1200&height=675&seq=article-tennis-01&orientation=landscape',
    author: '张华',
    publishDate: '2026-08-03',
    tags: ['网球', '郑钦文', '美网', '大滿贯'],
    viewCount: 39600,
    commentCount: 1678,
    isHot: false,
    isFeatured: false,
  },
  {
    id: '9',
    title: 'NBA夏季联赛：中国球员崔永熙表现抢眼，获多队关注',
    slug: 'nba-summer-league-cui-yongxi-2026',
    category: 'basketball',
    categoryName: '篮球',
    excerpt: '在NBA夏季联赛中，中国球员崔永熙代表开拓者队出战，场均得到15.3分、5.2篮板和3.1助攻，引起了多支NBA球队的关注。',
    content: `<p>在拉斯维加斯举行的NBA夏季联赛中，中国球员崔永熙代表波特兰开拓者队出战了全部五场比赛，展现出令人印象深刻的表现。</p>
    <h2>数据表现</h2>
    <p>崔永熙在五场比赛中场均出战28分钟，得到15.3分、5.2篮板、3.1助攻和1.4抢断，投篮命中率达到48.5%，三分球命中率为39.2%。</p>
    <p>在最后一场对阵湖人队的比赛中，崔永熙更是砍下22分8篮板4助攻的全面数据，帮助球队以108-102获胜。</p>
    <h2>球探评价</h2>
    <p>多支NBA球队的球探对崔永熙的表现给予了积极评价。一位东部球队的球探表示："崔永熙拥有出色的身体素质和全面的技术，他在防守端的积极性尤其令人印象深刻。他有潜力成为一名合格的NBA轮换球员。"</p>
    <p>崔永熙目前与开拓者队签有双向合同，新赛季他有望获得更多的NBA出场机会。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Asian%20basketball%20player%20dribbling%20in%20NBA%20summer%20league%20game%20with%20intense%20defense%2C%20professional%20sports%20photography%2C%20arena%20atmosphere%2C%20dynamic%20action%2C%20clean%20composition&width=1200&height=675&seq=article-basketball-03&orientation=landscape',
    author: '李明',
    publishDate: '2026-08-02',
    tags: ['NBA', '崔永熙', '夏季联赛', '中国篮球'],
    viewCount: 52100,
    commentCount: 1987,
    isHot: true,
    isFeatured: false,
  },
];

export function getArticlesByCategory(category: string): Article[] {
  return articles.filter((a) => a.category === category);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getLatestArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, limit);
}